module.exports = __webpack_public_path__ + "static/media/File-submitted-small.601b3c79.svg";